import React from 'react';
import { render, screen } from '@testing-library/react';
import '@testing-library/jest-dom';
import Purchase from './purchase';

describe('Purchase', () => {
  test('renders Purchase component', () => {
    const tickets = [{ id: 1, price: 1000, issue_number: 100, valid_period_day: 90 }]
    render(<Purchase m_tickets={tickets} />);

    // screen.debug();

    expect(screen.getByText(/1,000/)).toBeInTheDocument();
    expect(screen.getByText('チケット購入')).toBeInTheDocument();
  });
});
